export const SCHEMA_TYPE_CREDENTIALS = 'credentials';
export const SCHEMA_TYPE_ORGS = 'orgs';
export const SCHEMA_TYPE_USERS = 'users';
export const SCHEMA_TYPE_TEAMS = 'teams';
export const SCHEMA_TYPE_DATA_MAPS = 'dataMaps';

export const SCHEMA_TYPE_SOURCES = 'sources';
export const SCHEMA_TYPE_DATA_SETS = 'dataSets';
export const SCHEMA_TYPE_SINKS = 'sinks';
export const SCHEMA_TYPE_FLOW_NODES = 'flowNodes';
export const SCHEMA_TYPE_TRANSFORMS = 'transforms';
export const SCHEMA_TYPE_NOTIFICATIONS = 'notifications';
export const SCHEMA_TYPE_AUTH_INFO = 'session';
export const SCHEMA_TYPE_NOTIFICATION_TYPES = 'notificationTypes';
export const SCHEMA_TYPE_NOTIFICATION_CHANNELS = 'notificationChannels';
export const SCHEMA_TYPE_NOTIFICATION_SETTINGS = 'notificationSettings';
export const SCHEMA_TYPE_QUARNTINE = 'quarantineConfig';
export const SCHEMA_TYPE_VENDORS = 'vendors';
export const SCHEMA_TYPE_VENDOR_AUTH_PARAMS = 'vendorAuthParams';
export const SCHEMA_TYPE_VENDOR_AUTH_TEMPLATES = 'vendorAuthTemplates';
export const SCHEMA_TYPE_VENDOR_ENDPOINTS = 'vendorEndpoints';
export const SCHEMA_TYPE_VENDOR_ENDPOINT_PARAMS = 'vendorEndpointParams';

export const SCHEMA_TYPE_AUDIT_LOG = 'auditLog';
export const SCHEMA_TYPE_SCHEMA_SPECS = 'schemaSpecs';
export const SCHEMA_TYPE_API_KEY = 'apiKeys';
export const SCHEMA_TYPE_DOCS = 'docs';
export const SCHEMA_TYPE_PROJECTS = 'projects';
export const SCHEMA_TYPE_PROJECT_SOURCES = 'projectSources';
export const SCHEMA_TYPE_USER_SETTINGS = 'userSettings';
export const SCHEMA_TYPE_CATALOG_CONFIGS = 'catalogConfigs';
export const SCHEMA_TYPE_GEN_AI_CONFIGS = 'genAiConfigs';
export const SCHEMA_TYPE_SERVICE_KEY = 'serviceKeys';
export const SCHEMA_TYPE_SDK_APPLICATION = 'sdkApplications';
export const SCHEMA_TYPE_DOMAINS = 'domains';
export const SCHEMA_TYPE_MARKETPLACE_ITEMS = 'marketplaceItems';

export const SCHEMA_TYPE_CREDENTIALS_GROUPS = 'credentialsGroups';
